/**
 * 瀑布流工具函数 - 服务端安全版
 */

import type { NewShowCaseList } from '@/app/types';

/**
 * 瀑布流常量
 */
export const MASONRY_CONSTANTS = {
  SPACING: 4,
  DEFAULT_CELL: {
    HEIGHT: 250,
    WIDTH: 300,
  },
} as const;

/**
 * 列数预设类型
 */
export type ColumnsPreset = 'fewer' | 'default' | 'more' | 'activity';

/**
 * 百分比映射
 */
export const MARK_PERCENT_MAP = new Map<number, string>([
  [1, '28%'],
  [9, '16%'],
  [16, '50%'],
]);

/**
 * 获取高度百分比
 */
export const getPercentage = (width: number | undefined): string => {
  if (width === undefined) return '50%';
  return MARK_PERCENT_MAP.get(width) ?? '50%';
};

/**
 * 检查行是否已加载
 */
export const isRowLoaded = (inspAssets: NewShowCaseList) => {
  return ({ index }: { index: number }) => Boolean(inspAssets[index]);
};
